<style scoped lang="less">
// .upload-demo {
// 	position: relative;
// 	height: 20vh;
// 	left: 0;
// }
</style>

<template>
	<div>
		<!-- 	<el-upload show-file-list action="#" list-type="picture-card" :file-list="imglist" :limit="10"
			:on-change="changeinms" multiple :auto-upload="false" ref="pictureUpload">
			<i slot="default" class="el-icon-plus"></i>
			<div slot="file" slot-scope="{file}">
				<img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
				<span class="el-upload-list__item-actions">
					<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
						<i class="el-icon-zoom-in"></i>
					</span>
					<span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
						<i class="el-icon-delete"></i>
					</span>
				</span>
			</div>
		</el-upload> -->

		<!-- action="http://192.168.88.136/api/Train/UploadTrainImages" -->
		<el-upload
			show-file-list
			action="#"
			list-type="picture-card"
			:file-list="filelists"
			:limit="10"
			:on-preview="handlePictureCardPreview"
			:on-change="handleSuccess"
			:on-remove="handleRemove"
			multiple
			:auto-upload="false"
			ref="pictureUpload"
		>
			<!-- -->
			<i class="el-icon-plus"></i>
		</el-upload>
		<el-dialog title="修改头像" :visible.sync="dialogVisible" center width="80%">
			<div style="display: flex;align-items: center;justify-content: center;">
				<div style="display: flex;align-items: center;flex-direction: column;">
					<div style="width: 30rem;height: 30rem;">
						<vueCropper
							ref="cropper"
							:img="dialogImageUrl"
							:outputSize="option.outputSize"
							:outputType="option.outputType"
							:info="option.info"
							:full="option.full"
							:canMove="option.canMove"
							:canMoveBox="option.canMoveBox"
							:original="option.original"
							:autoCrop="option.autoCrop"
							:autoCropWidth="option.autoCropWidth"
							:autoCropHeight="option.autoCropHeight"
							:fixedBox="option.fixedBox"
							@realTime="realTime"
						></vueCropper>
					</div>
				</div>

				<div
					style="width: 30rem;
						display: flex;
						justify-content: space-evenly;
						align-items: center;
						margin-left: 1rem;"
				>
					<img :src="corappurl" alt="" style="width: 390px;height: 256px;border: 1px solid #ccc;" />
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="clenrsa()">取 消</el-button>
				<el-button type="primary" @click="changeheadimg()">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { getTrainImages } from '@/request/api/trainroom/trainroom.js';
import { setbaseurl, getBase64 } from '@/utils/utils.js';

import { VueCropper } from 'vue-cropper';

export default {
	props: {
		filelist: Array
	},
	data() {
		return {
			dialogImageUrl: '',
			dialogVisible: false,
			disabled: false,
			filelists: [],
			baseurl: '',
			token: 'Bearer ' + localStorage.getItem('token'),
			option: {
				img: '', // 裁剪图片的地址
				info: true, // 裁剪框的大小信息
				outputSize: 0.8, // 裁剪生成图片的质量
				outputType: 'jpeg', // 裁剪生成图片的格式
				canScale: false, // 图片是否允许滚轮缩放
				autoCrop: true, // 是否默认生成截图框
				autoCropWidth: 390, // 默认生成截图框宽度
				autoCropHeight: 256, // 默认生成截图框高度
				fixedBox: true, // 固定截图框大小 不允许改变
				fixed: false, // 是否开启截图框宽高固定比例
				fixedNumber: [5, 0], // 截图框的宽高比例
				full: true, // 是否输出原图比例的截图
				canMoveBox: true, // 截图框能否拖动
				original: true, // 上传图片按照原始比例渲染
				centerBox: true, // 截图框是否被限制在图片里面
				infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
			},
			corappurl: '',
			newfilenow: '',
			flefl: {}
		};
	},

	mounted() {
		this.baseurl = setbaseurl() + '/Train/UploadTrainImages';
		this.filelists = this.filelist;
	},
	components: {
		VueCropper
	},
	watch: {
		filelist(val) {
			this.filelists = val;
		}
	},
	methods: {
		clenrsa() {
			// this.filelists = []
			this.filelists.splice(this.filelists.indexOf(this.flefl), 1);
			this.$refs.pictureUpload.clearFiles();
			this.dialogVisible = false;
		},
		// 真实图片
		realTime(data) {
			// console.log(data);
			this.previews = data;
			let _this = this;
			this.$refs.cropper.getCropBlob(async data1 => {
				let formData = new FormData();
				if (data1) {
					var timestamp = new Date().getTime() + '.jpg';
					const newFile = new window.File([data1], timestamp);
					var src = window.URL.createObjectURL(newFile);
					_this.newfilenow = newFile;
					_this.corappurl = src;
				}
			});
		},
		changeheadimg() {
			// console.log(this.$refs.pictureUpload,"上传")
			this.$refs.pictureUpload.uploadFiles.forEach(item => {
				if (item.uid == this.dialogImageObj.uid) {
					item.url = this.corappurl;
				}
			});

			var form_data = new FormData();
			form_data.append('file', this.newfilenow);
			getTrainImages(form_data).then(res => {
				if (res.data.code == 1) {
					this.$message({
						message: res.data.msg,
						type: 'success'
					});
					let strlist = [];
					this.$refs.pictureUpload.uploadFiles.forEach(item => {
						if (item.uid == this.dialogImageObj.uid) {
							item.raw = this.newfilenow;
						}
					});

					this.$refs.pictureUpload.uploadFiles.forEach(item => {
						strlist.push(item.raw);
					});
					// this.$refs.pictureUpload.clearFiles();
					this.dialogVisible = false;

					this.$store.commit('changetrainimg', strlist);
				} else {
					this.$message(res.data.msg, '格式默认人为jpg/png');
				}
			});
		},

		// 上传文件列表
		handleSuccess(file, fileList) {
			this.flefl = file;
			this.handlePictureCardPreview(file);

			// console.log(fileList)
			// var strlist = []
			// fileList.forEach((item) => {
			// 	// strlist.push(item.url)
			// 	strlist.push(item.raw)
			// })

			// this.$store.commit("changetrainimg", strlist)
			// console.log(this.$store.state.trainimg)
		},
		handleRemove(file, fileList) {
			// console.log(file);
			var strlist = [];
			fileList.forEach(item => {
				// strlist.push(item.url)
				strlist.push(item.raw);
			});

			this.$store.commit('changetrainimg', strlist);

			// console.log(this.$store.state.trainimg)

			// console.log(this.$store.trainimg)
		},
		handlePictureCardPreview(file) {
			// console.log(file)
			this.dialogImageUrl = file.url;
			this.dialogImageObj = file;
			this.dialogVisible = true;
		}
	}
};
</script>

<style></style>
